import { render, staticRenderFns } from "./CBSQueue.vue?vue&type=template&id=7a1c35ac&"
import script from "./CBSQueue.vue?vue&type=script&lang=js&"
export * from "./CBSQueue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports